import React, { Component } from 'react'
import Helmet from 'react-helmet'

import SectionCaseStudies from '@/section-case-studies'
import SectionApply from '@/section-apply'

import shareImg from './images/case_studies.jpg'

class CaseStudies extends Component {
  render() {
    const { data } = this.props

    return (
      <div>
        <Helmet>
          <title>Case studies</title>
          <meta property="og:title" content="Case studies" />
          <meta property="og:description" content="We've worked with diverse clients, located across the globe." />
          <meta property="og:image" content={`https://nextmiss.com${shareImg}`} />
          <meta property="og:url" content="https://nextmiss.com/case_studies/" />
          <meta property="og:image:alt" content="Case studies - Next Miss" />
        </Helmet>
        <SectionCaseStudies data={data} />
        <SectionApply gray />
      </div>
    )
  }
}

export default CaseStudies

export const query = graphql`
  query CaseStudiesQuery {
    phoneMsAfrica: imageSharp(id: { regex: "/phoneMsAfrica/" }) {
      sizes(maxWidth: 591) {
        ...GatsbyImageSharpSizes
      }
    }
    phoneMsArmenia: imageSharp(id: { regex: "/phoneMsArmenia/" }) {
      sizes(maxWidth: 591) {
        ...GatsbyImageSharpSizes
      }
    }
    phoneMsFinland: imageSharp(id: { regex: "/phoneMsFinland/" }) {
      sizes(maxWidth: 591) {
        ...GatsbyImageSharpSizes
      }
    }
    phoneMsUssr: imageSharp(id: { regex: "/phoneMsUssr/" }) {
      sizes(maxWidth: 591) {
        ...GatsbyImageSharpSizes
      }
    }
    logoArmenia: imageSharp(id: { regex: "/logoArmenia/" }) {
      sizes(maxWidth: 204) {
        ...GatsbyImageSharpSizes
      }
    }
    logoMS: imageSharp(id: { regex: "/logoMS/" }) {
      sizes(maxWidth: 204) {
        ...GatsbyImageSharpSizes
      }
    }
    logoSA: imageSharp(id: { regex: "/logoSA/" }) {
      sizes(maxWidth: 204) {
        ...GatsbyImageSharpSizes
      }
    }
    logoUSSR: imageSharp(id: { regex: "/logoUSSR/" }) {
      sizes(maxWidth: 204) {
        ...GatsbyImageSharpSizes
      }
    }
    avatarAfrica: imageSharp(id: { regex: "/avatarAfrica/" }) {
      sizes(maxWidth: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    avatarArmenia: imageSharp(id: { regex: "/avatarArmenia/" }) {
      sizes(maxWidth: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    avatarFinland: imageSharp(id: { regex: "/avatarFinland/" }) {
      sizes(maxWidth: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    avatarUssr: imageSharp(id: { regex: "/avatarUssr/" }) {
      sizes(maxWidth: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    CaseStudies1: imageSharp(id: { regex: "/CaseStudies1/" }) {
      sizes(maxWidth: 1020) {
        ...GatsbyImageSharpSizes
      }
    }
    CaseStudies2: imageSharp(id: { regex: "/CaseStudies2/" }) {
      sizes(maxWidth: 1020) {
        ...GatsbyImageSharpSizes
      }
    }
    CaseStudies3: imageSharp(id: { regex: "/CaseStudies3/" }) {
      sizes(maxWidth: 1020) {
        ...GatsbyImageSharpSizes
      }
    }
    CaseStudies4: imageSharp(id: { regex: "/CaseStudies4/" }) {
      sizes(maxWidth: 1020) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/case_studies.js